import { AuthId, Path, StoreKey } from "@common/constans";
import { StorageType } from "@common/enum";
import { Account } from "./Account";
import Storage from "./Storage";

export interface IAuthentication {
    setAuth: (authId: string, transactionId: string, expires: number, callBackUrl: string) => void;
    getCallBackUrl: (authId: string) => string;
    getTransactionId: (authId: string) => string;
    removeAuth: (authId: string) => void;
}

export const Authentication: IAuthentication = () => { };

Authentication.setAuth = (authId: string, transactionId: string, expires: number, callBackUrl: string) => {
    const authentications = Storage.get<any>(StoreKey.Authentication, StorageType.Session) || {};
    if (!authentications[authId])
        authentications[authId] = {}
    authentications[authId].transactionId = transactionId;
    authentications[authId].expires = expires;
    authentications[authId].callBackUrl = getCallBackUrlById(authId, callBackUrl);
    Storage.set(StoreKey.Authentication, authentications, StorageType.Session);
}

Authentication.removeAuth = (authId: string) => {
    const authentications = Storage.get<any>(StoreKey.Authentication, StorageType.Session) || {};
    if (authentications[authId])
        delete authentications[authId];
    Storage.set(StoreKey.Authentication, authentications, StorageType.Session);
}

Authentication.getCallBackUrl = (authId: string) => {
    if (!authId)
        return "";
    const authentications = Storage.get<any>(StoreKey.Authentication, StorageType.Session) || {};
    const authentication = authentications[authId];
    return authentication?.callBackUrl ?? "";
}

Authentication.getTransactionId = (authId: string) => {
    if (!authId)
        return "";
    const authentications = Storage.get<any>(StoreKey.Authentication, StorageType.Session) || {};
    const authentication = authentications[authId];
    return authentication?.transactionId ?? "";
}

function getCallBackUrlById(id: string, callBackUrl: string) {
    switch (id) {
        case AuthId.FlightSurvay:
            return callBackUrl;
        case AuthId.ManageBooking:
            return Account.isGuest() ? Path.Booking.ReservationStatus : Path.Profile.History;
        case AuthId.OnlineCheckin:
            return Path.Checkin.Login;
        default:
            return Path.Home;
    }
}